import Axios from "axios";
import qs from 'qs'
import { useCommon } from '@/store/useCommon';
import pinia from '@/store'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'

/**url:http://192.168.30.251:8600 */
const testBalanceInstance = Axios.create({
  //baseURL: 'http://192.168.30.251:8600', //公网221.4.223.110 本地用代理的时候为''，线上要改成http地址，目前还有跨域问题这个得后端解决
  baseURL: '',
  timeout: 60000,
})

const dynamicInstance = Axios.create({
  baseURL: '',
  timeout: 60000,
})

/**直接使用传输过来的url请求 */
const useParamsUrlInstance = Axios.create({
  baseURL: '',
  timeout: 60000,
})

// 对象转化为键=值形式字符串
function iterateProperties(obj) {  
  return Object.keys(obj).reduce(function(str, key) {  
    const pair = key + '=' + obj[key];  
    str += `${pair}&`;  
    return str;  
  }, '');  
}


// 工具函数，用于动态拼接 baseURL
function getServiceUrl(serviceName) {
  // 根据 serviceName 动态拼接 baseURL
  if (serviceName === '/aaa/ott/login') {
    return useCommon().traceDebugUrl
  } else if (serviceName === '/balance/getAAAServer') {
    return localStorage.getItem('balanceUrl')
  }
  else if(serviceName === '/epgserver/index/index' || serviceName === '/agent/agent' || serviceName === '/epgserver/channel/channelList') {
    return 'http://192.168.30.251:8290'
  }
  else {
    return 'http://localhost:3000'
  }
}

// 请求拦截器，在请求发送之前做一些处理
dynamicInstance.interceptors.request.use((config: AxiosRequestConfig & DefaultObjectType) => {
  
  // 利用工具函数动态拼接 baseURL
  config.baseURL = getServiceUrl(config.url)

  if (config?.type == 'upload') {
    config.headers['Content-Type'] = 'multipart/form-data'
  } else if (config?.type == 'json') {
    config.headers['Content-Type'] = 'application/json'
  }else {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.data = qs.stringify(config.data, {
      arrayFormat: config.arrayFormat || 'indices',
      allowDots: true,
    })
  }

  //格式化data参数
  config.transformRequest = [function(data, headers) {
    return qs.parse(qs.stringify(data,{
      arrayFormat: config.arrayFormat || 'indices',
      allowDots: true,
    }))
  }]

  // 格式化params参数
  config.paramsSerializer = (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' })
  }
  
  const storeCommon = useCommon()
  const { token, userData } = storeCommon
  if (token) config.headers['token'] = token
  // console.log('cid',userData.cid[0])
  if (userData.cid) config.headers['cid'] = userData.cid[0] === undefined ? sessionStorage.getItem('currentCid')?sessionStorage.getItem('currentCid'):0  : userData.cid[0]

  config.headers['userId'] = userData.id
  config.headers['current_username'] = userData.name
  config.headers['current_id'] = userData.id
  return config
})
// 响应拦截1
dynamicInstance.interceptors.response.use((result: AxiosResponse) => {
  let logDataObj = {
    url: result.request.responseURL,
    data: result.data
  }
  const storeCommon = useCommon()
  storeCommon.addShowLogData(logDataObj)
  return result
}, err => {
  console.error(err)
  return Promise.reject(err)
})



// 请求拦截器，在请求发送之前做一些处理
useParamsUrlInstance.interceptors.request.use((config: AxiosRequestConfig & DefaultObjectType) => {

  if (config?.type == 'upload') {
    config.headers['Content-Type'] = 'multipart/form-data'
  } else if (config?.type == 'json') {
    config.headers['Content-Type'] = 'application/json'
  }else {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.data = qs.stringify(config.data, {
      arrayFormat: config.arrayFormat || 'indices',
      allowDots: true,
    })
  }

  //格式化data参数
  config.transformRequest = [function(data, headers) {
    return qs.parse(qs.stringify(data,{
      arrayFormat: config.arrayFormat || 'indices',
      allowDots: true,
    }))
  }]

  // 格式化params参数
  config.paramsSerializer = (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' })
  }
  
  const storeCommon = useCommon()
  return config
})


// 响应拦截
useParamsUrlInstance.interceptors.response.use((result: AxiosResponse) => {
  //console.log('看看index',result.config)
  let logDataObj = {
    url: result.config.url,
    data: result.data
  }

  //把index接口的params转化为字符串，再拼接到result.config.url
  if(result.config.url.indexOf('index')>-1) {
    //console.log('是index接口',result.config)
    if(result.config.params) {
      let str = iterateProperties(result.config.params)
      let logStr = result.config.url.split('?')[0]+ '?' + str .substring(0, str.length - 1)
      logDataObj.url = logStr
    }
  }

  const storeCommon = useCommon()
  storeCommon.addShowLogData(logDataObj)
  return result
}, err => {
  console.error(err)
  return Promise.reject(err)
})




/**分别配置对应的请求拦截器和响应拦截器 */
// 请求拦截1
testBalanceInstance.interceptors.request.use((config: AxiosRequestConfig & DefaultObjectType) => {
  if (config?.type == 'upload') {
    config.headers['Content-Type'] = 'multipart/form-data'
  } else if (config?.type == 'json') {
    config.headers['Content-Type'] = 'application/json'
  }else {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.data = qs.stringify(config.data, {
      arrayFormat: config.arrayFormat || 'indices',
      allowDots: true,
    })
  }

  //格式化data参数
  config.transformRequest = [function(data, headers) {
    return qs.parse(qs.stringify(data,{
      arrayFormat: config.arrayFormat || 'indices',
      allowDots: true,
    }))
  }]

  // 格式化params参数
  config.paramsSerializer = (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' })
  }
  
  const storeCommon = useCommon()
  // console.log('api', storeCommon.userData)
  // 添加token

  // const { token, userData } = storeCommon
  // if(token) config.headers['token'] = token
  // // console.log('cid',userData.cid[0])
  // if(userData.cid) config.headers['cid'] = userData.cid[0]
  return config
}, err => {
  console.error(err)
  return Promise.reject(err)
})

// 响应拦截1
testBalanceInstance.interceptors.response.use((result: AxiosResponse) => {
  return result
}, err => {
  console.error(err)
  return Promise.reject(err)
})


export {
  testBalanceInstance,
  dynamicInstance,
  useParamsUrlInstance
}